<!-- 上传文件 -->
<template>
  <zlr-modal v-model="uplpadShow">
    <div class="upload-file">
      <h1>Upload</h1>
      <div class="upload-file-handle">
        <upload :path='path'
                v-model="filePath"
                on-error="uploadError"
                @on-success="upSucHandle"></upload>
      </div>
      <div class="upload-file-btn">
        <Button class="zlr-btn-default"
                @click="uplpadShow = false">Close</Button>
        <div class="zlr-inlin-block"
             :class="{'zlr-cover': !filePath}">
          <Button class="zlr-btn-primary"
                  @click="subHandle">Submit</Button>
        </div>
      </div>
    </div>
  </zlr-modal>
</template>
<script>
// componnets
import ZlrModal from '_c/modal/modal'
import Upload from '_c/upload/upload'
export default {
  name: 'apply-mentor-upload',
  props: ['path'],
  components: {
    ZlrModal,
    Upload
  },
  data () {
    return {
      uplpadShow: false,
      filePath: '',
      file: ''
    }
  },
  computed: {},
  mounted () { },
  methods: {
    showHandle () {
      this.uplpadShow = true
    },
    subHandle () {
      this.uplpadShow = false
      this.$emit('up-success', {
        name: this.file.name,
        path: this.filePath
      })
    },
    upSucHandle (f) {
      this.file = f
    }
  },
  watch: {
    uplpadShow () {
      this.filePath = ''
      this.file = ''
    }
  }
}
</script>
<style lang='less' scoped>
</style>
